import React, { useEffect, useState } from 'react';
import SingleBlog from '../SingleBlog/SingleBlog';
import './Blog.css'

const Blog = () => {
    const [blogs, setBlogs] = useState([]);
    useEffect(() => {
        fetch('./blog.json')
            .then(res => res.json())
            .then(data => setBlogs(data))
    }, [])
    return (
        <div id='blog' className='main-blog'>
            <div className="row">
                <div className="container col-lg-12">
                    < small className='text-danger fs-4 fw-bold'>Blog</small >
                    <h2 className='section'>My Blog

                    </h2>

                </div>
            </div>
            <div class="row row-cols-1 row-cols-md-3 g-4 mt-5">
                {
                    blogs.map(blog => <SingleBlog
                        key={blog.id}
                        blog={blog}
                    >

                    </SingleBlog>)
                }
            </div>


        </div>


    );
};


export default Blog;